import { render, staticRenderFns } from "./DonorAnalysis.vue?vue&type=template&id=8cbe973a&scoped=true&"
import script from "./DonorAnalysis.vue?vue&type=script&lang=js&"
export * from "./DonorAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./DonorAnalysis.vue?vue&type=style&index=0&id=8cbe973a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cbe973a",
  null
  
)

export default component.exports